import { Vue, getElementData } from '@/main/appBluePrint'
import App from '@/apps/Facilities'

import * as VueGoogleMaps from 'vue2-google-maps'
import GmapCluster from 'vue2-google-maps/dist/components/cluster'

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAmpGT5xkkLtHg4cMVloNZOqw-d1qNAF6I'
  }
})

Vue.component('GmapCluster', GmapCluster)

import store from '@/store/index'
import '@/store/modules/Facets'
import '@/store/modules/Results'
import '@/store/modules/Schedule'
import '@/store/modules/Selected'
import '@/store/modules/Facilities'

const element = document.getElementById('facilities')
const elementData = getElementData(element)

new Vue({
  store,
  render: (h) => h(App, { props: { elementData } })
}).$mount(element)
